module.exports = __webpack_public_path__ + "media/images/icons/like-66d02af8c14609831756b8565a060418.svg";